import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { ShortCutKey2 } from '../GridAssets/GridAssetsData';
import { iconsPath } from '../../utils/imagePath';
import useClickOutside from '../UseClickOutside';

const RightMenuShortcutKey = ({ handlePopupToggle, setIsPopupOpen }) => {
  const modalVariants = {
    hidden: { opacity: 0, scale: 0.8, x: 50 }, // Start slightly left and scaled down
    visible: { opacity: 1, scale: 1, x: 0, transition: { duration: 0.2 } }, // Animate to full size
    exit: { opacity: 0, scale: 0.8, x: 50 }, // Exit to the right
  };

  const modelRef = useRef(null);
  useClickOutside(modelRef, () => {
    setIsPopupOpen(null);
  });

  return (
    <div className="flex justify-center items-center w-full">
      <motion.div
        ref={modelRef}
        variants={modalVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="bg-[#131418] h-fit z-[99999999] w-[340px] relative flex items-center justify-center   p-3 rounded-lg shadow-lg"
      >
        <button
          onClick={() => handlePopupToggle(null)}
          className="absolute top-[12px] right-3 text-[#D9D9D9] z-[999] hover:text-white text-lg "
        >
          <img
            className="h-4 w-4 z-[999]"
            src={iconsPath?.group112Image}
            alt=""
          />
        </button>
        {/* <ul className="-mx-3">
          {ShortCutKey2.map((item, index) =>
            item.gap ? (
              <li key={index} className="border-b border-[#2B2B2B] my-1"></li>
            ) : item.heading ? (
              <li
                key={index}
                className="bg-[#AE2525] px-3 py-2 mb-2 relative bottom-[12px] rounded-tl-md rounded-tr-md"
              >
                <span className="text-white text-sm font-medium">
                  {item.heading}
                </span>
              </li>
            ) : (
              <li 
                key={index} 
                className={`py-[4px] px-[5px] mx-3 text-[#D9D9D9] ${
                  item.onClick ? 'hover:bg-[#37383F] cursor-pointer rounded' : ''
                }`}
                onClick={() => item.onClick?.()}
              >
                <h1 className="font-normal text-[12px] flex items-center justify-start">
                  <span className="text-[#FFF]">{item.key}</span>
                  <div className="min-w-[230px] pl-16 ml-auto">
                    <span className="font-normal text-[10px] text-[#D9D9D9] whitespace-nowrap">
                      {item.title}
                    </span>
                  </div>
                </h1>
              </li>
            )
          )}
        </ul> */}



        <ul className="-mx-3">
  {ShortCutKey2.map((item, index) =>
    item.gap ? (
      <li key={index} className="border-b border-[#2B2B2B] my-1"></li>
    ) : item.heading ? (
      <li
        key={index}
        className="bg-[#AE2525] px-3 py-2 mb-2 relative bottom-[12px] rounded-tl-md rounded-tr-md"
      >
        <span className="text-white text-sm font-medium">
          {item.heading}
        </span>
      </li>
    ) : (
      <li
        key={index}
        className={`py-[4px] px-[5px] mx-3 text-[#D9D9D9] ${
          item.onClick ? 'hover:bg-[#37383F] cursor-pointer rounded' : ''
        }`}
        onClick={() => item.onClick?.()}
      >
        <h1 className="font-normal text-[12px] flex items-center justify-start">
          <span className="text-[#FFF]">{item.key}</span>
          <div className="min-w-[230px] pl-16 ml-auto">
            <span className="font-normal text-[10px] text-[#D9D9D9] whitespace-nowrap">
              {item.title}
            </span>
          </div>
        </h1>
      </li>
    )
  )}
</ul>

      </motion.div>
    </div>
  );
};

export default RightMenuShortcutKey;
